import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FacebookShareButton, FacebookShareCount, TwitterShareButton, PinterestShareButton} from 'react-share';
import {faFacebookF, faTwitter, faPinterestP} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './ShareButtons.scss';
const {SITE_URL} = process.env;

export default function ShareButtons(props) {
  return (
    <>
      {props.floating ? (
        <div className="social-share social-share-floating">
          <ShareButtonsList {...props} />
        </div>
      ) : (
        <>
          {props.shareText ? (
            <div className="social-share-copy d-flex align-items-center justify-content-center">
              <div className="social-share-text mb-2 mb-sm-0 mr-sm-2">Share on social:</div>
              <div className="social-share d-flex align-items-center justify-content-center">
                <ShareButtonsList {...props} noDescription />
              </div>
            </div>
          ) : (
            <div className={classNames('social-share d-flex align-items-center', props.alignment)}>
              <ShareButtonsList {...props} noDescription />
            </div>
          )}
        </>
      )}
    </>
  );
}

ShareButtons.defaultProps = {
  alignment: 'justify-content-center justify-content-lg-end'
};

export function ShareButtonsList({
  shareUrl = `${SITE_URL}`,
  shareImg = 'https://cdn.foodrevolution.org/ff/og/ff-evergreen-opengraph-landingpage-1200x1200-v20220719.png',
  facebookDescription = 'A beautiful story of solutions! Researchers are using fungi to solve some of the world’s biggest problems, including climate change, pollution, mental wellness, and more. Join us for this special event edition of Fantastic Fungi right now — for free! Watch here:',
  twitterDescription = '“Fantastic Fungi is a must-see…” - Forbes. Catch the special event edition of @FantasticFungi FREE for 4 days! #mushroom Watch here:',
  twitterHashtags = [''],
  twitterImg = 'https://cdn.foodrevolution.org/ff/og/ff-evergreen-opengraph-landingpage-1200x675-v202207019.png',
  pinterestDescription = 'A beautiful story of solutions! Researchers are using fungi to solve some of the world’s biggest problems, including climate change, pollution, mental wellness, and more. Join us for this special event edition of Fantastic Fungi right now — for free! Watch here:',
  pinterestImg = 'https://cdn.foodrevolution.org/ff/og/ff-evergreen-opengraph-landingpage-1000x1500-v202207019.png',
  noDescription = false,
  ...props
}) {
  return (
    <>
      {noDescription ? null : (
        <div className="social-button">
          <div className="btn btn-social btn-social-share">Shares</div>
        </div>
      )}

      <FacebookShareButton className="social-button" url={shareUrl} quote={facebookDescription}>
        <div className="btn btn-social btn-social-facebook">
          <FontAwesomeIcon className="social-button-icon" icon={faFacebookF} />
          <span className="btn-social-description btn-social-description-facebook d-none d-md-inline">Facebook</span>
        </div>
      </FacebookShareButton>

      <TwitterShareButton
        className="social-button"
        url={shareUrl}
        media={twitterImg}
        via="afoodrevolution"
        hashtags={twitterHashtags}
        title={twitterDescription}
      >
        <div className="btn btn-social btn-social-twitter">
          <FontAwesomeIcon className="social-button-icon" icon={faTwitter} />
          <span className="btn-social-description btn-social-description-twitter d-none d-md-inline">Twitter</span>
        </div>
      </TwitterShareButton>

      <PinterestShareButton
        className="social-button"
        url={shareUrl}
        media={pinterestImg}
        description={pinterestDescription}
      >
        <div className="btn btn-social btn-social-pinterest">
          <FontAwesomeIcon className="social-button-icon" icon={faPinterestP} />
          <span className="btn-social-description btn-social-description-pinterest d-none d-md-inline">Pinterest</span>
        </div>
      </PinterestShareButton>
    </>
  );
}
